import _ from "lodash";
import under from "underts";
import { HMObject } from "../../types/HMObject.js";
const horairesExtremesForWeek = (horaireRecord) => {
    if (!horaireRecord || !horaireRecord.horaire) {
        return;
    }
    const horaire = horaireRecord.horaire;
    const startBornes = under.sortBy(Object.values(horaire)
        .flat()
        .map((plage) => plage.start), (hm) => hm.hour * 60 + hm.minute);
    const endBornes = under.sortBy(Object.values(horaire)
        .flat()
        .map((plage) => plage.end), (hm) => hm.hour * 60 + hm.minute);
    // const startBornes = _.chain(horaire)
    //   .values()
    //   .flatten()
    //   .map("start")
    //   .sortBy((hm) => hm.heure * 60 + hm.minute)
    //   .value();
    // const endBornes = _.chain(horaire)
    //   .values()
    //   .flatten()
    //   .map("end")
    //   .sortBy((hm) => hm.heure * 60 + hm.minute)
    //   .value();
    const start = under.first(startBornes);
    const end = under.last(endBornes);
    if (!start || !end) {
        return;
    }
    return {
        start,
        end,
    };
};
const horairesExtremesForDay = (bornes) => {
    return ((bornes.length > 0 && {
        start: _.first(bornes).start,
        end: _.last(bornes).end,
    }) ||
        undefined);
};
const longestRdvPossible = (horaireRecord) => {
    const horaire = horaireRecord.horaire;
    return Object.values(horaire).reduce((max, dayPlages) => {
        const dayMax = dayPlages.reduce((max, plage) => {
            return Math.max(max, plage.end.hour * 60 +
                plage.end.minute -
                plage.start.hour * 60 -
                plage.start.minute);
        }, 0);
        return Math.max(max, dayMax);
    }, 0);
};
const getDebutHeureAffichage = (horaireExtremesForWeek) => {
    return new HMObject(horaireExtremesForWeek.start).valueOf();
};
const getFinHeureAffichage = (horaireExtremesForWeek) => {
    return new HMObject(horaireExtremesForWeek.end).valueOf();
};
export { horairesExtremesForWeek, horairesExtremesForDay, longestRdvPossible, getDebutHeureAffichage, getFinHeureAffichage, };
//# sourceMappingURL=horairesExtremesForWeek.js.map